// removed by extract-text-webpack-plugin
module.exports = {"user":"user__1IwHL","image":"image__1J0H5","profile-photo":"profile-photo__2j2iK","number":"number__1mIsi","average-rating":"average-rating__1FWc3","sort":"sort__1XD9_"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/UserRankings/User/styles.scss
// module id = ./app/scripts/views/App/views/UserRankings/User/styles.scss
// module chunks = 1